import PasswordResetConnector from './PasswordResetScreenConnector';

export default PasswordResetConnector;
